'use strict';

import React, {useCallback, useMemo} from 'react';
import {h, Fragment} from 'preact';
import mix from '../../../../helpers/mix';
import {trans} from '../../../../l10n';
import LikeButton from '../LikeButton';
import Availability from '../Availability';
import Mix from '../../../../helpers/mix';
import {discount} from '../../Partnership';

export default function ItemDesktop(props) {
    const product = useMemo(() => props.product, [props.product]);

    const view = useMemo(() => {
        let view = global.config.productsCookieView;

        if (props.view) {
            view = props.view;
        }

        if (!view) {
            view = 'grid';
        }

        return view;
    }, [props.view]);

    const addToBasket = useCallback(
        ev => {
            ev.preventDefault();

            window.addToBascet(product.id, product.unlocalizedName, product.detailName, product.detailKogo, '', ~~props.reload_page);
        },
        [product.id, props.reload_page, props.preserve_cart]
    );

    const gaEvent = useCallback(() => {
        typeof ga !== 'undefined' && ga?.getAll()?.[0]?.send('event', 'КаталогМоделей', 'ЗаказатьВ1Клик');
    }, []);

    const discounted = useMemo(() => {
        return global.config.isPartnerMode ? discount(product.price.final_price) : null;
    }, [product.price]);

    return (
        <div className='item js-good' data-id={product.id}>
            {props.fromFavorites && (
                <div className='favorites-close'>
                    <a href='#' className='js-remove-favorite favorites-close-link'>
                        <img src={mix.img('/images/cross-icon.png')} />
                    </a>
                </div>
            )}

            <div className='item_shadow'>
                <div className='item_h'>
                    <a className='main_link' href={product.url} title={product.name} tabIndex='-1'>
                        <div className='img_block'>
                            {props.lazyload ? (
                                <img data-original={product.imageUrl} alt={product.alt} className='lazy' />
                            ) : (
                                <img src={product.imageUrl} alt={product.alt} />
                            )}

                            {
                                // Этот товар можно покрутить в 3D
                                !!product.photos3D && (
                                    <div className='threeD' title={trans('catalog.3dphoto_hint_short')}></div>
                                )
                            }

                            {
                                // Гарантия
                                !!product.warranty && (
                                    <div
                                        className={`guarantee_block`}
                                        title={product.warrantyText}
                                        style={{
                                            background: `url(${Mix.img(
                                                '/images/icon/' + product.warranty + '.png'
                                            )}) no-repeat`,
                                        }}></div>
                                )
                            }

                            {
                                // Есть уцененный товар
                                !!product.price_down && (
                                    <div
                                        className='ucenka'
                                        title={trans('catalog.have_ucenka_products')}
                                        style={{
                                            background: `url(${Mix.img(
                                                '/images/' + product.priceDownValue + '-1.png'
                                            )}) no-repeat`,
                                        }}></div>
                                )
                            }

                            {product.sticker !== null && <div dangerouslySetInnerHTML={{__html: product.sticker}}></div>}
                        </div>

                        <h3>{product.name}</h3>
                    </a>

                    <div className='price'>
                        {/*Снято с продажи/производства*/}

                        {product.availableValue ? (
                            <>
                                {/* цена */}

                                {
                                    <>
                                        <div className='number'>
                                            <span>{trans('catalog.price_small')}</span>
                                            &nbsp;
                                            <span className='price_value'>{product.price.final_price}</span>
                                            &nbsp;
                                            <span className='price_currency'>{product.price.show_symb}</span>
                                        </div>

                                        {discounted !== null && (
                                            <div className='number'>
                                                <span className='catalog_price_old' style={{float: 'none!important'}}>
                                                    <span className='price_value'>{discounted}</span>
                                                    &nbsp;
                                                    <span className='price_currency'>{product.price.show_symb}</span>
                                                </span>
                                            </div>
                                        )}
                                    </>
                                }

                                {!props.hide_retail_price && global.config.isMaster && (
                                    <div
                                        className='number price_roznica list'
                                        style={view !== 'list' ? {display: 'none'} : {}}>
                                        <span>{trans('catalog.price_roznicnaya')}</span>
                                        &nbsp;
                                        <span className='price_value'>{product.priceRetail}</span>
                                        &nbsp;
                                        <span className='price_currency'>{product.price.show_symb}</span>
                                    </div>
                                )}

                                {view === 'list' && !props.hide_favorite && (
                                    <>
                                        {global.config.isOperator ? (
                                            <div
                                                className={'like-btn list ' + (view === 'list') ? '' : ' hidden'}
                                                style={{
                                                    float: 'none',
                                                    display: 'inline-block',
                                                    margin: 0,
                                                    marginTop: '-3px',
                                                    background: 'none',
                                                }}>
                                                <a
                                                    href='#'
                                                    className='js-interest-toggle'
                                                    data-good-id={product.id}
                                                    title={trans('catalog.interest')}
                                                    style={{padding: 0, background: 'none'}}>
                                                    <img src={mix.img('images/vopros.jpg')} width='20' />
                                                </a>
                                            </div>
                                        ) : (
                                            <div
                                                className={
                                                    'like-btn list ' +
                                                    (product.favorite ? ' active' : '') +
                                                    (view === ' list' ? '' : ' hidden')
                                                }
                                                style={{
                                                    float: 'none',
                                                    display: 'inline-block',
                                                    margin: '-5px 0 0',
                                                }}>
                                                <a
                                                    href='#'
                                                    className='js-favorite-toggle'
                                                    data-good-id={product.id}
                                                    title={trans('catalog.add_to_favorite')}></a>
                                            </div>
                                        )}
                                    </>
                                )}
                            </>
                        ) : (
                            product.hide_availability && <div className='in_stock'>{product.available}</div>
                        )}

                        {product.commentsCount > 0 && (
                            <noindex is='noindex'>
                                <a href={product.url} className='reviews' rel='nofollow'>
                                    {product.commentsCount} {product.commentsCountText}
                                </a>
                            </noindex>
                        )}
                    </div>

                    <div className='bot_block'>
                        {!props.hide_retail_price && global.config.isMaster && (
                            <div className='number price_roznica grid' style={view === 'list' ? {display: 'none'} : {}}>
                                <span>{trans('catalog.price_roznicnaya')}</span>
                                &nbsp;
                                <span className='price_value'>{product.priceRetail}</span>
                                &nbsp;
                                <span className='price_currency'>{product.price.show_symb}</span>
                            </div>
                        )}

                        {/*Артикул*/}
                        <div className='in_stock' style={{color: '#adadad', 'font-size': '11px', 'padding-bottom': '3px'}}>
                            {trans('catalog.field_articul')} {product.articul}
                        </div>

                        {/*Снято с продажи/производства*/}
                        {product.availableValue && (
                            <>
                                <Availability {...props} view={view} />

                                {/*добавить в корзину*/}
                                <a href='#' className='butBlue' onClick={addToBasket}>
                                    {trans('catalog.add_to_cart')}
                                </a>

                                {view === 'grid' && <LikeButton {...{product, view}} />}

                                {global.config.country === 'UA' && !props.hide_one_click_order && (
                                    <a
                                        href='#'
                                        className='one_click_btn js-one-click-btn'
                                        data-nameov={product.detailName}
                                        data-namea={product.detailKogo}
                                        data-name={product.unlocalizedName}
                                        onClick={gaEvent}>
                                        {trans('catalog.one_click_buy')}
                                    </a>
                                )}
                            </>
                        )}

                        {props.read_more && (
                            <noindex is='noindex'>
                                <a href={product.url} className='liked' rel='nofollow'>
                                    <span>{trans('catalog.goto_product')}</span>
                                </a>
                            </noindex>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
